import ServiceCRUD from '../../../../services/ServiceCRUDFLEXCHAT';
import { apiCrm } from '../../../../http';

class ProposalService extends ServiceCRUD {
  constructor() {
    super('/proposal');
  }

  async createProposal(data) {
    return apiCrm.post(`/proposal`, data);
  }

  async getAllProposals(page, size, query, { showDisable = false }) {
    // Sempre usa o endpoint /proposal e passa textQuery como parâmetro
    return apiCrm.get(`/proposal`, {
      params: {
        page,
        limit: size,
        textQuery: query || undefined,
        showDisable
      }
    });
  }

  async getProposalById(id) {
    return apiCrm.get(`/proposal/${id}`);
  }

  async putProposalById(id, data) {
    return apiCrm.put(`/proposal/${id}`, data);
  }

  async deleteProposalById(id) {
    return apiCrm.delete(`/proposal/${id}`);
  }
  async enableProposalById(id, newStatus) {
    return apiCrm.put(`/proposal/status/${id}`, {
      active: newStatus
    });
  }

  async updateProposalLogo(data) {
    return apiCrm.put('/proposal/logo', data);
  }

  async getProposalLogo(proposalId) {
    const proposal = await this.getProposalById(proposalId);
    const attachments =
      proposal?.data?.data?.attachments || proposal?.data?.attachments;

    if (!attachments || attachments.length === 0) {
      throw new Error('Nenhuma logo encontrada para esta proposta');
    }

    const logoAttachment = attachments[0];
    const logoPath = logoAttachment.path;

    const baseUrl = process.env.REACT_APP_CRM_URL.replace('/api', '');
    const logoUrl = `${baseUrl}/${logoPath}`;

    return apiCrm.get(logoUrl, {
      responseType: 'blob',
      baseURL: ''
    });
  }
}
export default new ProposalService();
